module.exports = __webpack_public_path__ + "img/center_air.24b51715.png";